import React from "react";
import { Gift, CreditCard, ShoppingBag, Shirt, Sparkles, DollarSign } from "lucide-react";

const META = {
  cash: { icon: DollarSign, label: "Cash", color: "#76B82A" },
  gift_card: { icon: CreditCard, label: "Gift Card", color: "#D7A62A" },
  gift: { icon: Gift, label: "Gift", color: "#D7A62A" },
  merch: { icon: Shirt, label: "Merch", color: "#F5F2E8" },
  other: { icon: Sparkles, label: "Prize", color: "#F5F2E8" },
};

export function prizeMeta(drop) {
  const t = drop?.prize_type || "cash";
  return META[t] || META.cash;
}

/** Inline pill: e.g. ⓖ "GIFT CARD · STARBUCKS" */
export function PrizeTypeBadge({ drop, size = "xs" }) {
  if (!drop || (drop.prize_type || "cash") === "cash") return null;
  const m = prizeMeta(drop);
  const Icon = m.icon;
  const extra = drop.prize_custom_label ? ` · ${drop.prize_custom_label}` : "";
  const textSize = size === "sm" ? "text-xs" : "text-[10px]";
  return (
    <span
      className={`tag-pill inline-flex items-center gap-1 ${textSize}`}
      style={{ color: m.color, borderColor: m.color }}
      data-testid={`prize-badge-${drop.prize_type}`}
    >
      <Icon size={10} /> {m.label.toUpperCase()}
      {extra && <span className="opacity-80 normal-case">{extra}</span>}
    </span>
  );
}

/** Big display used in hero sections: $100 (or "Gift Card — Starbucks") */
export function PrizeHeroLabel({ drop, className = "" }) {
  const t = drop?.prize_type || "cash";
  const amt = Number(drop?.amount || 0);
  if (t === "cash") {
    return (
      <span className={className} data-testid="prize-hero-cash">
        ${amt ? amt.toLocaleString() : "—"}
      </span>
    );
  }
  const m = prizeMeta(drop);
  const custom = drop?.prize_custom_label || "";
  return (
    <span className={className} data-testid={`prize-hero-${t}`}>
      {m.label}
      {custom && (
        <span className="opacity-80"> · {custom}</span>
      )}
      {amt > 0 && (
        <span className="opacity-60 text-base ml-2">
          (~${amt.toLocaleString()} value)
        </span>
      )}
    </span>
  );
}
